import styled from 'styled-components';

const RecipesItemStyle = styled.div`
	--recipesItemBorderRadius: var(--sp2x);
	--recipesItemBottomContentPadTB: var(--sp4x);
	--recipesItemBottomContentPadLR: var(--sp4x);
	--recipesItemBottomContentGap: var(--sp2x);

	--recipesItemImageSize: 84.9%;

	overflow: hidden;
	border-radius: var(--recipesItemBorderRadius);

	.recipes-item-info-wrapper {
		padding: var(--recipesItemBottomContentPadTB) var(--recipesItemBottomContentPadLR);
		background-color: var(--green100);
	}

	.recipes-item-info-inner-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--recipesItemBottomContentGap);
	}

	.recipes-item-image-wrapper {
		overflow: hidden;
		isolation: isolate;
		backface-visibility: visible;
	}

	.image-cont {
		--proportion: var(--recipesItemImageSize);

		will-change: transform;
		transition: transform 0.4s ease-out;
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			&:hover {
				.image-cont {
					transform: scale(1.1);
				}
			}
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--recipesItemBorderRadius: var(--sp2x);
		--recipesItemBottomContentPadTB: var(--sp3x);
		--recipesItemBottomContentPadLR: var(--sp2-5x);
		--recipesItemBottomContentGap: var(--sp1-5x);

		--recipesItemImageSize: 83.8%;
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--recipesItemBorderRadius: var(--sp2x);
		--recipesItemBottomContentPadTB: 18px;
		--recipesItemBottomContentPadLR: var(--sp2x);
		--recipesItemBottomContentGap: var(--sp1-5x);

		--recipesItemImageSize: 83.8%;
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--recipesItemBorderRadius: var(--sp1-5x);
		--recipesItemBottomContentPadTB: var(--sp2x);
		--recipesItemBottomContentPadLR: var(--sp1-5x);
		--recipesItemBottomContentGap: var(--sp1-5x);

		--recipesItemImageSize: 93.3%;
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--recipesItemBorderRadius: var(--sp1-5x);
		--recipesItemBottomContentPadTB: var(--sp2x);
		--recipesItemBottomContentPadLR: var(--sp1-5x);
		--recipesItemBottomContentGap: var(--sp1-5x);

		--recipesItemImageSize: 93.1%;
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--recipesItemBorderRadius: var(--sp1x);
		--recipesItemBottomContentPadTB: var(--sp1-5x);
		--recipesItemBottomContentPadLR: var(--sp1-5x);
		--recipesItemBottomContentGap: var(--sp1x);

		--recipesItemImageSize: 93%;
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--recipesItemBorderRadius: var(--sp1x);
		--recipesItemBottomContentPadTB: var(--sp1x);
		--recipesItemBottomContentPadLR: var(--sp1x);
		--recipesItemBottomContentGap: var(--sp1x);

		--recipesItemImageSize: 92.3%;
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--recipesItemBorderRadius: var(--sp1x);
		--recipesItemBottomContentPadTB: var(--sp1x);
		--recipesItemBottomContentPadLR: var(--sp1x);
		--recipesItemBottomContentGap: var(--sp1x);

		--recipesItemImageSize: 93%;
	}
`;

export default RecipesItemStyle;
